export default __webpack_public_path__ + "static/media/159327057_875500426583355_5194432796591816134_n.13e328b3.jpg";